import { Link } from 'react-router-dom';
import { ExternalLink } from './icons';
import type { ReactNode } from 'react';
import logoUrl from '../assets/logo.webp';

export function Footer() {
  return (
    // 无界浅色 footer：底色与页面一致(bg-canvas)，顶部不加分隔线，靠留白与正文自然过渡；
    // 颜色全走语义 token，随 data-theme 自动明暗翻转（不再是硬编码 slate 深色条）。
    <footer className="bg-canvas text-fg-muted">
      <div className="mx-auto w-full max-w-[1600px] px-5 py-10 sm:px-6 sm:py-12">
        <div className="flex flex-col gap-10 md:flex-row md:flex-wrap md:items-start md:gap-x-12 md:gap-y-8">
          {/* 链接列：手机 3 列紧凑网格；md+ 用 contents 还原为 flex 行内项 */}
          <div className="grid grid-cols-3 gap-x-4 gap-y-6 md:contents">
          <FooterColumn title="产品">
            <FooterLink to="/datasets">数据集浏览</FooterLink>
            {/* 会员套餐入口暂时下线（/pricing 路由保留，仅从 footer 隐藏） */}
            <FooterLink to="/redeem">兑换码</FooterLink>
            <FooterLink to="/profile">个人中心</FooterLink>
          </FooterColumn>

          <FooterColumn title="资源">
            <FooterLink to="/data-sources">数据来源说明</FooterLink>
            <FooterLink to="/terms">使用条款</FooterLink>
            <FooterLink to="/privacy">隐私政策</FooterLink>
          </FooterColumn>

          <FooterColumn title="数据库导航">
            <FooterLink to="/datasets?cat=company&lv=category">上市公司数据</FooterLink>
            <FooterLink to="/datasets?cat=province&lv=category">省级宏观数据</FooterLink>
            <FooterLink to="/datasets?cat=city&lv=category">地级市数据</FooterLink>
          </FooterColumn>
          </div>

          <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:flex-wrap sm:items-start sm:justify-center sm:gap-x-12 md:ml-auto md:justify-start md:text-left">
            {/* 移动端(堆叠)：特别鸣谢在上、关于我们在下；sm+ 行布局还原为 关于我们左 / 特别鸣谢右 */}
            <div className="order-2 sm:order-1">
              <h3 className="mb-4 text-xs font-medium tracking-widest text-fg-subtle">
                关于我们
              </h3>
              {/* 去掉旧的 brightness(0) invert(1) 白抜滤镜；改用 .header-logo：
                  亮色原色藏青、暗色自动提亮（与顶栏 logo 一致）。 */}
              <img
                src={logoUrl}
                alt="知行数据分析"
                className="header-logo mx-auto h-14 w-auto md:mx-0"
              />
            </div>

            <div className="order-1 sm:order-2">
              <h3 className="mb-4 text-xs font-medium tracking-widest text-fg-subtle">
                特别鸣谢
              </h3>
              {/* .endorsement-logo 统一处理：亮色灰度(hover 恢复原色)、暗色反相提亮；
                  opacity/hover 由该类接管，故 <a> 不再叠自己的 opacity。 */}
              <a
                href="https://cemer.com.cn"
                target="_blank"
                rel="noopener noreferrer"
                title="CEMER · 中实嘉数研究数据库"
                className="inline-block"
              >
                <img
                  src="/cemer-fulllogo.svg"
                  alt="CEMER · 中实嘉数研究数据库"
                  className="endorsement-logo h-12 w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 版权/备案条：顶部分隔线不做整页全宽，仅限安全区(max-w 容器)之内；
          底部内边距含 env(safe-area-inset-bottom)，viewport-fit=cover 后避开 iOS 底部指示条 */}
      <div className="mx-auto flex w-full max-w-[1600px] flex-col items-center gap-1.5 border-t border-line-subtle px-4 pb-[calc(1.25rem+env(safe-area-inset-bottom))] pt-5 text-center text-xs text-fg-subtle sm:px-6">
        <p>© 2026 知行经管数据 · 学术数据下载平台</p>
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 hover:text-fg"
        >
          沪ICP备2024088194号-1
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </footer>
  );
}

function FooterColumn({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div>
      <h3 className="mb-4 text-xs font-medium tracking-widest text-fg-subtle">{title}</h3>
      <ul className="flex flex-col gap-2 text-sm">{children}</ul>
    </div>
  );
}

function FooterLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <li>
      <Link to={to} className="text-fg-muted hover:text-fg">
        {children}
      </Link>
    </li>
  );
}
